/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {
  createRef,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useParams } from 'react-router-dom';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ArrowBack from '@mui/icons-material/ArrowBack';
import { styled } from '@mui/system';
import { MdClose, MdDelete } from 'react-icons/md';

import api, { authHeader } from '../../../../../../services/API/apiConfig';

import { ImageSlider } from '../../../../../components/ImageSlider/ImageSlider';
import { DialogBox } from '../../../../../components/singleComponents/dialogs/DialogBox';
import { Dropzone } from '../../../../../components/singleComponents/dropzone/Dropzone';
import { NewFolder } from '../../../../../components/singleComponents/modals/NewFolder';
import ToasterBox from '../../../../../components/singleComponents/toaster/ToasterBox';
import { TableFolder } from '../documents/TableFolder';

import GlobalContext from '../../../../../../context/GlobalContext';
import {
  BtnFolderStyled,
  ContainerFolderNameStyled,
  DefaultPageStyled,
  DivBtnsStyled,
  FolderIconStyled,
  HeaderPageStyled,
  LoaderContainerStyled,
  LoadingProgressStyled,
  MainDivStyled,
  ModalStyled,
  PreviewStyled,
  RootStyled,
  SelectionDefaultStyled,
  UploadContainerStyled,
} from './ConstructionPhotos.styles';

const Backdrop = styled('div')`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255);
  -webkit-tap-highlight-color: transparent;
`;

export function ConstructionPhotos() {
  const {
    companyData: { subdomain },
  } = useContext(GlobalContext);

  const { id } = useParams();

  const baseURL = process.env.REACT_APP_API;
  const protocol = subdomain.endsWith('-st') ? 'http' : 'https';
  const formData = false;

  const [titleModal, setTitleModal] = useState('Nova pasta');
  const [folderId, setFolderId] = useState(null);
  const [folderModal, setFolderModal] = useState(false);
  const [openDialogFolder, setOpenDialogFolder] = useState(false);
  const [rowId, setRowId] = useState(null);
  const [foldersShow, setFolderShow] = useState(true);
  const [selectedFolder, setSelectedFolder] = useState([]);
  const [folderPictures, setFolderPictures] = useState([]);
  const [showToaster, setShowToaster] = useState(false);
  const [toasterMessage, setToasterMessage] = useState('');
  const [imageFile, setImageFile] = useState([]);
  const [folders, setFolders] = useState([]);
  const [construction, setConstruction] = useState([]);
  const [isSelected, setIsSelected] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isUploading, setUploading] = useState(false);
  const [post, setPost] = useState(true);

  const header = [' ', 'Pasta', 'Data da última modificação'];
  const row = ['name', 'last_modified'];

  const pictureInputRefs = useMemo(() => {
    const refs = {};
    folderPictures.forEach((picture) => {
      refs[picture.id] = createRef(null);
    });
    return refs;
  }, [folderPictures]);

  const getFolders = async () => {
    await api
      .get(`/constructions/${id}/picture-folders`, {
        headers: authHeader(formData),
      })
      .then((res) => {
        const { data } = res.data;
        setFolders(data);
        setLoading(false);
        setUploading(false);
      });
  };

  const handleCreateNewFolder = () => {
    setFolderId(null);
    setFolderModal(!folderModal);
  };

  const editFolderName = (idRow) => {
    setTitleModal('Editar nome da pasta');
    setFolderId(idRow);
    setFolderModal(!folderModal);
  };

  async function deleteFolder(idRow) {
    await api
      .delete(`/folders/${idRow}`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { status, messages } = res.data;
        if (status === 0) {
          setToasterMessage(messages);
          setShowToaster(true);
          getFolders();
          setOpenDialogFolder(false);
        }
      });
  }

  const returnId = async (idRow) => {
    setSelectedFolder(idRow);
    setFolderId(idRow.id);

    if (idRow.id) {
      await api
        .get(`/folders/${idRow.id}/pictures`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          setFolderShow(false);
          setFolderPictures(data);
        });
    }
  };

  function handleChangeCheckbox(e) {
    const { name, value, checked } = e.target;

    if (name === 'allSelect') {
      const tempImg = folderPictures.map((image) => ({
        ...image,
        isChecked: checked,
      }));
      setFolderPictures(tempImg);
    } else {
      const tempImg = folderPictures.map((image) => {
        if (image.id === Number(value)) {
          return { ...image, isChecked: checked };
        }
        return image;
      });
      setFolderPictures(tempImg);
    }
  }

  function deletePictures() {
    setOpenDialog(false);

    const checks = folderPictures.map((picture) => picture?.isChecked);
    if (checks.every((check) => !check)) {
      setErrorMessage(true);
      setTimeout(() => {
        setErrorMessage(false);
      }, 1500);
    }

    folderPictures.forEach((picture) => {
      if (picture && picture.isChecked) {
        api.delete(`/pictures/${picture.id}`, {
          headers: authHeader(formData),
        });
      }
    });

    setTimeout(() => {
      setIsSelected(false);
      returnId(selectedFolder);
    }, 1500);
  }

  useEffect(() => {
    api
      .get(`/constructions/${id}`, {
        headers: authHeader(formData),
      })
      .then((res) => {
        const { data } = res.data;
        setConstruction(data);
      });
  }, []);

  useEffect(() => {
    if (post) {
      getFolders();
      returnId(selectedFolder);
    }
    setPost(false);
  }, [post]);

  return (
    <>
      {showToaster && <ToasterBox message={toasterMessage} />}
      <Paper>
        <RootStyled>
          <HeaderPageStyled>
            <Typography style={{ fontSize: '24px' }} variant="h1">
              {construction.name}
            </Typography>
            <UploadContainerStyled>
              {!foldersShow && (
                <>
                  <Dropzone
                    file={imageFile}
                    setFile={setImageFile}
                    route={`/folders/${folderId}/pictures`}
                    setUploading={setUploading}
                    setPost={setPost}
                  />
                  {isUploading && (
                    <LoaderContainerStyled>
                      <CircularProgress size={28} />
                    </LoaderContainerStyled>
                  )}
                </>
              )}
              {foldersShow && (
                <BtnFolderStyled
                  id="create-folder"
                  color="secondary"
                  variant="contained"
                  onClick={handleCreateNewFolder}
                >
                  Criar pasta
                </BtnFolderStyled>
              )}
            </UploadContainerStyled>
          </HeaderPageStyled>
          {loading ? (
            <LoadingProgressStyled>
              <Typography variant="h2">Carregando...</Typography>
              <LinearProgress style={{ width: '80%' }} />
            </LoadingProgressStyled>
          ) : (
            <>
              <ContainerFolderNameStyled>
                {!foldersShow && (
                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    startIcon={<ArrowBack />}
                    onClick={() => setFolderShow(true)}
                  >
                    Retornar para lista de pastas
                  </Button>
                )}
              </ContainerFolderNameStyled>
              {!foldersShow && (
                <MainDivStyled>
                  {folderPictures && (
                    <>
                      <SelectionDefaultStyled>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 7,
                          }}
                        >
                          <Typography variant="subtitle2">
                            TODAS AS FOTOS
                          </Typography>
                          <Typography style={{ fontSize: 14, color: '#999' }}>
                            {`${folderPictures.length} fotos`}
                          </Typography>
                        </div>
                        {!isSelected && (
                          <Typography
                            className="typography"
                            onClick={() => setIsSelected(!isSelected)}
                          >
                            Selecionar
                          </Typography>
                        )}
                      </SelectionDefaultStyled>
                      {isSelected && (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '0 12px',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: 12,
                            }}
                          >
                            <input
                              type="checkbox"
                              name="allSelect"
                              onChange={handleChangeCheckbox}
                              checked={
                                !folderPictures.some(
                                  (image) => image?.isChecked !== true
                                )
                              }
                            />
                            <Typography
                              variant="subtitle2"
                              className="selectAll"
                            >
                              Selecionar todos
                            </Typography>
                          </div>
                          <DivBtnsStyled>
                            <Typography
                              variant="subtitle2"
                              className="cancel"
                              onClick={() => {
                                setIsSelected(!isSelected);
                              }}
                            >
                              Cancelar
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              className="delete"
                              onClick={() => setOpenDialog(true)}
                            >
                              <MdDelete color="red" size="21" />
                              Remover
                            </Typography>
                          </DivBtnsStyled>
                        </div>
                      )}
                      {errorMessage && (
                        <Stack sx={{ width: '100%' }} spacing={2}>
                          <Alert severity="error">
                            Selecione pelo menos uma imagem
                          </Alert>
                        </Stack>
                      )}
                      <PreviewStyled>
                        {loading ? (
                          <dLoadingProgressStyled>
                            <Typography variant="h2">Carregando...</Typography>
                            <LinearProgress style={{ width: '80%' }} />
                          </dLoadingProgressStyled>
                        ) : (
                          // eslint-disable-next-line react/jsx-no-useless-fragment
                          <>
                            {folderPictures.lenght !== 0 &&
                              folderPictures.map((image, imageIndex) => (
                                <div
                                  key={image.id}
                                  className={`${image?.isChecked ? 'selectedImage' : 'image'}`}
                                >
                                  {isSelected && (
                                    <input
                                      ref={pictureInputRefs[image.id]}
                                      type="checkbox"
                                      name={image && image.name}
                                      checked={image?.isChecked || false}
                                      onChange={handleChangeCheckbox}
                                      value={image.id}
                                      style={{ display: 'none' }}
                                    />
                                  )}
                                  <img
                                    src={`${protocol}://${subdomain}.${baseURL}${image.path.thumbnails.medium}`}
                                    alt={image.name}
                                    style={{ cursor: isSelected && 'pointer' }}
                                    onClick={() => {
                                      setIndex(imageIndex);
                                      return isSelected
                                        ? pictureInputRefs[
                                            image.id
                                          ].current.click()
                                        : setOpenModal(true);
                                    }}
                                  />
                                </div>
                              ))}
                          </>
                        )}
                      </PreviewStyled>
                    </>
                  )}
                </MainDivStyled>
              )}
              {foldersShow && (
                <TableFolder
                  data={folders}
                  headings={header}
                  keys={row}
                  editActions
                  foldersShow={foldersShow}
                  buttonEditFunction={editFolderName}
                  buttonDeleteFunction={(selectedId) => {
                    setOpenDialogFolder(!openDialogFolder);
                    setRowId(selectedId);
                  }}
                  callbackClickRow={returnId}
                />
              )}
              {!folders.length && (
                <DefaultPageStyled>
                  <FolderIconStyled />
                  <Typography style={{ fontSize: '12px' }}>
                    Nenhuma pasta foi adicionada até o momento
                  </Typography>
                </DefaultPageStyled>
              )}
            </>
          )}
        </RootStyled>
      </Paper>
      <NewFolder
        title={titleModal}
        open={folderModal}
        folderId={folderId}
        kind="picture"
        onClose={() => setFolderModal(!folderModal)}
        runAfterSave={() => getFolders()}
      />
      <DialogBox
        title="Remover pasta"
        content="Deseja realmente remover esta pasta? Esta ação não poderá ser desfeita"
        openDialog={openDialogFolder}
        closeDialog={() => setOpenDialogFolder(!openDialogFolder)}
        mainAction={() => deleteFolder(rowId)}
      />
      <DialogBox
        title="Remover foto"
        content="Deseja realmente remover essa(s) foto(s)? Essa ação não poderá ser desfeita."
        openDialog={openDialog}
        closeDialog={() => setOpenDialog(false)}
        mainAction={() => deletePictures()}
      />
      <ModalStyled
        open={openModal}
        onClose={() => setOpenModal(false)}
        slot={{
          Backdrop: () => Backdrop,
        }}
      >
        <>
          <IconButton
            className="close"
            onClick={() => setOpenModal(false)}
            size="large"
          >
            <MdClose />
          </IconButton>
          <ImageSlider
            slides={folderPictures}
            setSlides={setFolderPictures}
            index={index}
          />
        </>
      </ModalStyled>
    </>
  );
}
